import './assets/main.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { createVuetify } from 'vuetify'
import { customSVGs } from './assets/customSvg'
import { datadogRum } from '@datadog/browser-rum'
import { init as initFullStory } from '@fullstory/browser'
import App from './App.vue'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import router from './router'
import 'vuetify/styles'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import * as Sentry from '@sentry/vue'

const app = createApp(App)

Sentry.init({
  app,
  dsn: 'https://b44590d999902194fee5c5644a616516@o173174.ingest.us.sentry.io/4508892456222720',
  integrations: [],
  enabled: import.meta.env.VITE_APP_ENVIRONMENT === 'production',
})

const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)

const vuetify = createVuetify({
  components,
  defaults: {
    VBtn: {
      rounded: 'lg',
    },
    VTextField: {
      rounded: 'lg',
    },
  },
  directives,
  icons: {
    sets: {
      custom: customSVGs,
    },
  },
})

datadogRum.init({
  applicationId: import.meta.env.VITE_DATADOG_APPLICATION_ID,
  clientToken: import.meta.env.VITE_DATADOG_CLIENT_TOKEN,
  // `site` refers to the Datadog site parameter of your organization
  // see https://docs.datadoghq.com/getting_started/site/
  site: 'datadoghq.com',
  service: 'careers-frontend',
  env: import.meta.env.APP_ENVIRONMENT,
  sessionSampleRate: 100,
  sessionReplaySampleRate: 20,
  defaultPrivacyLevel: 'mask-user-input',
})

initFullStory({ orgId: 'JSY6X' })

app.use(router)
app.use(vuetify)
app.use(pinia)

app.mount('#app')
